import { useTranslation } from 'react-i18next';

type Props = {};

export function Hero(props: Props) {
    const { t } = useTranslation();

    return (
        <div
            className="hero"
            style={{
                backgroundImage: `url("/images/image1.jpg")`,
                minHeight: '30vh',
                backgroundPosition:"0% 15%",
            }}
        >
        </div>
    );
}
